import { Icon, Input } from '@chakra-ui/react';
import { CalendarIcon } from '@heroicons/react/24/outline';
import { InputGroup } from '@/components/ui/input-group';
import { useFillableBlockResponse } from './common';
import BaseInputBlock from './base-input-block';
import { DateBlock as IDateBlock, DateType } from '@/lib/types';
import { ymdRegex, datetimeRegex } from '@/lib/helpers';

interface Props {
  block: IDateBlock;
}

export default function DateBlock({ block }: Props) {
  const { payload, updatePayload } = useFillableBlockResponse({ block });

  return (
    <BaseInputBlock block={block}>
      <InputGroup startElement={<Icon as={CalendarIcon} />} w={'full'}>
        <Input
          id={`block-${block.referenceID}`}
          value={payload?.value || ''}
          type={block.properties.dateType === DateType.Datetime ? 'datetime-local' : 'date'}
          max={'9999-12-31'}
          pattern={
            block.properties.dateType === DateType.Datetime ? datetimeRegex.source : ymdRegex.source
          }
          onChange={(e) => updatePayload({ value: e.currentTarget.value })}
        />
      </InputGroup>
    </BaseInputBlock>
  );
}
